import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as loginReducer from '@login/ngrx/login.reducer';

export interface State {
  login: loginReducer.State;
}

export const reducers: ActionReducerMap<State, any> = {
  login: loginReducer.reducer
};

export const selectLoginState = createFeatureSelector<loginReducer.State>('login');

/** Select Current User */
export const selectCurrentUser = createSelector(
  selectLoginState,
  (state) => state.currentUser
);

/** Select Permissions */
export const selectPermissions = createSelector(
  selectLoginState,
  (state) => state.permissions
);
